var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaucion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_2",
    "data-name": "Capa 2",
    viewBox: "0 0 846.25 417.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: gray;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #fff;\n        font-size: 20.36px;\n      }\n\n      .cls-2, .cls-4 {\n        font-family: Montserrat-Bold, Montserrat;\n        font-weight: 700;\n      }\n\n      .cls-5, .cls-4 {\n        fill: #4d4d4d;\n      }\n\n      .cls-6 {\n        fill: #ffa25f;\n      }\n\n      .cls-7 {\n        letter-spacing: 0em;\n      }\n\n      .cls-8 {\n        letter-spacing: 0em;\n      }\n\n      .cls-9 {\n        fill: #ed7850;\n      }\n\n      .cls-10 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-11 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-3 {\n        font-family: Montserrat-Medium, Montserrat;\n        font-weight: 500;\n      }\n\n      .cls-12 {\n        letter-spacing: 0em;\n      }\n\n      .cls-13 {\n        fill: none;\n        stroke: #4d4d4d;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n\n      .cls-14 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-15 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-16 {\n        letter-spacing: 0em;\n      }\n\n      .cls-17 {\n        letter-spacing: 0em;\n      }\n\n      .cls-4 {\n        font-size: 19px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "301.02 189.7 250.16 189.7 250.16 193.14 301.02 193.13 293.62 200.53 296.05 202.96 307.6 191.42 296.48 180.29 294.05 182.72 301.02 189.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 236.75,
    cy: 191.02,
    r: 13.13,
    transform: "translate(17.56 401.95) rotate(-82.8)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "220.2 231.45 271.07 231.45 271.07 228.01 220.2 228.01 227.6 220.61 225.17 218.18 213.62 229.73 224.74 240.85 227.18 238.42 220.2 231.45"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 284.47,
    cy: 230.13,
    r: 13.13,
    transform: "translate(17.88 480.75) rotate(-82.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 321.34,
    y: 0,
    width: 200,
    height: 90,
    rx: 12,
    ry: 12
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(375.62 52.41)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "BROKER")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 321.34,
    y: 163.7,
    width: 200,
    height: 90,
    rx: 12,
    ry: 12
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(382.32 203.02)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 0,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 15.5,
    y: 0
  }, "gen"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 56.67,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 65.19,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: -5.44,
    y: 24.44
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.06,
    y: 24.44
  }, "duanal")), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(232.52 197.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1")), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(277.41 236.2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4")), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(93.84 285.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "5")), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(554.51 197.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2")), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(602.32 236.2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 321.34,
    y: 327.06,
    width: 200,
    height: 90,
    rx: 12,
    ry: 12
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(344.34 379.47)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "IMPO"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 58.22,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 72.99,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 84.86,
    y: 0
  }, "ADOR"))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 163.7,
    width: 200,
    height: 90,
    rx: 12,
    ry: 12
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(59.66 216.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 0,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.8,
    y: 0
  }, "duana")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 0,
    y: 327.06,
    width: 200,
    height: 90,
    rx: 12,
    ry: 12
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(39.57 365.26)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Me"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 31.91,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 40.02,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 51.64,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 63.88,
    y: 0
  }, "de"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 90.23,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 98.44,
    y: 0
  }, "\xEDa"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.1,
    y: 24.44,
    xmlSpace: "preserve"
  }, " Libe"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 59.71,
    y: 24.44
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 67.89,
    y: 24.44
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 80.13,
    y: 24.44
  }, "da"))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 646.25,
    y: 163.7,
    width: 200,
    height: 90,
    rx: 12,
    ry: 12
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(677.51 216.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 0,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.8,
    y: 0
  }, "segu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 65.31,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 73.49,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 85.73,
    y: 0
  }, "do"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 112.55,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 120.74,
    y: 0
  }, "a")), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "461.3 305.92 461.3 275.91 457.87 275.91 457.87 305.92 450.47 298.52 448.04 300.95 459.58 312.5 470.71 301.37 468.28 298.94 461.3 305.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "381.38 272.49 381.38 302.49 384.81 302.49 384.81 272.49 392.21 279.89 394.64 277.46 383.1 265.91 371.97 277.03 374.4 279.47 381.38 272.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "461.3 141.77 461.3 111.77 457.87 111.77 457.87 141.77 450.47 134.38 448.04 136.81 459.58 148.35 470.71 137.23 468.28 134.8 461.3 141.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "381.38 108.35 381.38 138.35 384.81 138.35 384.81 108.35 392.21 115.74 394.64 113.31 383.1 101.77 371.97 112.89 374.4 115.32 381.38 108.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "624.04 189.7 573.17 189.7 573.17 193.14 624.04 193.13 616.64 200.53 619.07 202.96 630.62 191.42 619.49 180.29 617.06 182.72 624.04 189.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 559.77,
    cy: 191.02,
    r: 13.13,
    transform: "translate(300.07 722.42) rotate(-82.8)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "543.22 231.45 594.08 231.45 594.08 228.01 543.22 228.01 550.62 220.61 548.18 218.18 536.64 229.73 547.76 240.85 550.19 238.42 543.22 231.45"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 607.49,
    cy: 230.13,
    r: 13.13,
    transform: "translate(297.08 800.78) rotate(-82.2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "101.93 305.92 101.93 291.86 98.49 291.86 98.49 305.92 91.09 298.52 88.66 300.95 100.21 312.5 111.34 301.37 108.91 298.94 101.93 305.92"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 100,
    cy: 279.33,
    r: 13.13,
    transform: "translate(-192.27 228.32) rotate(-60.4)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaucion);
export default __webpack_public_path__ + "static/media/caucion.efc7faafbf8587dee0270ad678417b3b.svg";
export { ForwardRef as ReactComponent };